//Import required modules
import React from 'react';
import PropTypes from 'prop-types'
import { Component } from 'react'

//Import required Components
import Navbar from './Utils/Navbar'
import Content from './Utils/Content'

import {changeMedia, updateColorAttr} from '../store/actions'

class App extends Component {

  getChildContext() {
      return {
          store: this.props.store
      }
  }

  componentWillMount() {
      this.unsubscribe = this.props.store.subscribe(
          () => this.forceUpdate()
      )
  }

  componentWillUnmount() {
      this.unsubscribe()
  }

  componentDidMount(){
    console.log('component mounted')
    this.props.store.dispatch(changeMedia())
    this.props.store.dispatch(updateColorAttr(this.props.store.getState().userWindow))
    // document.getElementById("colorClipDiv").style.transition = "all 2s";
  }

  render() {
      return (
        <>
          <Navbar />
          <Content />
        </>
      )
  }
}

App.propTypes = {
  store: PropTypes.object.isRequired
}

App.childContextTypes = {
  store: PropTypes.object.isRequired
}

export default App
